module.exports = __webpack_public_path__ + "static/application-filters-9c72e36f446b16806945d693de00e312.png";